import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n/I18nProvider';
import { Logo } from '../components/Logo';
import api, { setAdminToken, getAdminToken } from '../lib/api';
import { ADMIN } from '../constants/testIds';

export default function AdminLoginPage() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (getAdminToken()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      setAdminToken(data.access_token);
      navigate('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Erreur de connexion.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-paper flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-pure border border-sand p-10">
        <Logo />
        <h1 className="font-serif text-3xl text-ink mt-10">{t('admin.loginTitle')}</h1>
        <form onSubmit={submit} className="mt-8 space-y-6">
          <label className="block">
            <span className="tm-label">{t('admin.email')}</span>
            <input
              data-testid={ADMIN.loginEmail}
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="tm-input"
            />
          </label>
          <label className="block">
            <span className="tm-label">{t('admin.password')}</span>
            <input
              data-testid={ADMIN.loginPassword}
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="tm-input"
            />
          </label>
          {error && <p data-testid={ADMIN.loginError} className="text-sm text-red-600">{error}</p>}
          <button
            data-testid={ADMIN.loginSubmit}
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center disabled:opacity-50"
          >
            {loading ? '…' : t('admin.login')}
          </button>
        </form>
      </div>
    </main>
  );
}
